import React from 'react';
import DiscountTable from 'components/receipt/commons/ListItemBox/DiscountTable';
import PropTypes from 'prop-types';
import { rupiah } from 'utils/formatter';
import RewardRedemptionInfo from 'components/receipt/commons/ListItemBox/RewardRedemptionInfo';
import styles from './ListItem.css';
import ItemTable from './ItemTable';

class ReceiptListItem extends React.Component {
  render() {
    const { invoiceDetail } = this.props;
    const { loyalty } = invoiceDetail;

    if (invoiceDetail.checkouts.length > 0) {
      return (
        <div className={styles['receipt-list-item-box']}>
          <ItemTable
            checkouts={invoiceDetail.checkouts}
            checkoutPriceFormatter={rupiah}
          />
          <DiscountTable discounts={invoiceDetail.payment_discounts} />
          {loyalty && loyalty.redemption && loyalty.redemption.reward && (
            <RewardRedemptionInfo
              redeemReward={
                loyalty.redemption.reward_checkout_title ||
                loyalty.redemption.reward
              }
              totalRedeemAmount={invoiceDetail.total_redeem_amount}
            />
          )}
        </div>
      );
    }
    const items = [];
    for (
      let keys = Object.keys(invoiceDetail.checkouts), i = 0, end = keys.length;
      i < end;
      i++
    ) {
      const salesType = keys[i];
      let item = null;
      if (
        Object.keys(invoiceDetail.checkouts).length <= 1 &&
        (salesType === '' || salesType === 'No Sales Type')
      ) {
        item = (
          <div className={styles['receipt-list-item-box']}>
            <ItemTable
              checkouts={invoiceDetail.checkouts[salesType]}
              checkoutPriceFormatter={rupiah}
            />
            <DiscountTable discounts={invoiceDetail.payment_discounts} />
            {loyalty && loyalty.redemption && loyalty.redemption.reward && (
              <RewardRedemptionInfo
                redeemReward={
                  loyalty.redemption.reward_checkout_title ||
                  loyalty.redemption.reward
                }
                totalRedeemAmount={invoiceDetail.total_redeem_amount}
              />
            )}
          </div>
        );
      } else if (i !== end - 1) {
        item = (
          <div className={styles['receipt-list-item-box']}>
            <div className={styles['sales-type-title']}>
              {salesType === '' || salesType === 'No Sales Type'
                ? 'No Sales Type'
                : salesType}
            </div>
            <ItemTable
              checkouts={invoiceDetail.checkouts[salesType]}
              checkoutPriceFormatter={rupiah}
            />
          </div>
        );
      } else {
        item = (
          <div className={styles['receipt-list-item-box']}>
            <div className={styles['sales-type-title']}>
              {salesType === '' || salesType === 'No Sales Type'
                ? 'No Sales Type'
                : salesType}
            </div>
            <ItemTable
              checkouts={invoiceDetail.checkouts[salesType]}
              checkoutPriceFormatter={rupiah}
            />
            <DiscountTable discounts={invoiceDetail.payment_discounts} />
            {loyalty && loyalty.redemption && loyalty.redemption.reward && (
              <RewardRedemptionInfo
                redeemReward={
                  loyalty.redemption.reward_checkout_title ||
                  loyalty.redemption.reward
                }
                totalRedeemAmount={invoiceDetail.total_redeem_amount}
              />
            )}
          </div>
        );
      }
      items.push(item);
    }
    return <div>{items}</div>;
  }
}

ReceiptListItem.propTypes = {
  invoiceDetail: PropTypes.object,
};

export default ReceiptListItem;
